export default "__VITE_ASSET__C144Kkip__"